module.exports = __webpack_public_path__ + "img/file-icon_other.1460112b.svg";